import airtel_logo from '../assets/airtel.png';
import vodacom_logo from '../assets/vodacom.png';
import tigo_logo from '../assets/tigo.png';
import halopesa_logo from '../assets/halopesa.png';
import zantel_ezypesa_logo from '../assets/ezypesa2.png';

export default [
  {
    code: 'vodacom',
    name: 'invoice_flow__vodacom',
    logo: vodacom_logo,
    accent: [4],
    steps: [
      'invoice_flow__vodacom_steps_step_1',
      'invoice_flow__vodacom_steps_step_2',
      'invoice_flow__vodacom_steps_step_3',
      'invoice_flow__vodacom_steps_step_4',
      'invoice_flow__vodacom_steps_step_5',
      'invoice_flow__vodacom_steps_step_6',
      'invoice_flow__vodacom_steps_step_7',
      'invoice_flow__vodacom_steps_step_8',
    ],
  },
  {
    code: 'airtel_money',
    name: 'invoice_flow__airtel',
    logo: airtel_logo,
    accent: [5],
    steps: [
      'invoice_flow__airtel_steps_step_1',
      'invoice_flow__airtel_steps_step_2',
      'invoice_flow__airtel_steps_step_3',
      'invoice_flow__airtel_steps_step_4',
      'invoice_flow__airtel_steps_step_5',
      'invoice_flow__airtel_steps_step_6',
      'invoice_flow__airtel_steps_step_7',
    ],
  },
  {
    code: 'tigo_pesa',
    name: 'invoice_flow__tigo',
    logo: tigo_logo,
    accent: [4],
    steps: [
      'invoice_flow__tigo_steps_step_1',
      'invoice_flow__tigo_steps_step_2',
      'invoice_flow__tigo_steps_step_3',
      'invoice_flow__tigo_steps_step_4',
      'invoice_flow__tigo_steps_step_5',
      'invoice_flow__tigo_steps_step_6',
      'invoice_flow__tigo_steps_step_7',
    ],
  },
  {
    code: 'halo_pesa',
    name: 'invoice_flow__halopesa',
    logo: halopesa_logo,
    accent: [4],
    steps: [
      'invoice_flow__halopesa_steps_step_1',
      'invoice_flow__halopesa_steps_step_2',
      'invoice_flow__halopesa_steps_step_3',
      'invoice_flow__halopesa_steps_step_4',
      'invoice_flow__halopesa_steps_step_5',
      'invoice_flow__halopesa_steps_step_6',
      'invoice_flow__halopesa_steps_step_7',
      'invoice_flow__halopesa_steps_step_8',
    ],
  },
  {
    code: 'zantel_ezypesa',
    name: 'invoice_flow__zantel_ezypesa',
    logo: zantel_ezypesa_logo,
    accent: [4],
    steps: [
      'invoice_flow__zantel_ezypesa_steps_step_1',
      'invoice_flow__zantel_ezypesa_steps_step_2',
      'invoice_flow__zantel_ezypesa_steps_step_3',
      'invoice_flow__zantel_ezypesa_steps_step_4',
      'invoice_flow__zantel_ezypesa_steps_step_5',
      'invoice_flow__zantel_ezypesa_steps_step_6',
      'invoice_flow__zantel_ezypesa_steps_step_7',
    ],
  },
];
